import { Section, SectionTypes } from '.'

export const Integration = {
    /**
     * True if the account has any conversion actions of the GA4 type:
     * https://developers.google.com/google-ads/api/fields/v25/conversion_action#conversion_action.google_analytics_4_settings.event_name
     */
    ga4: 'ga4',
    /**
     * True if the account has organic clicks here:
     * https://developers.google.com/google-ads/api/fields/v25/paid_organic_search_term_view
     */
    searchConsole: 'searchConsole',
    /**
     * True if the account has any `location_sync` assets:
     * https://developers.google.com/google-ads/api/docs/assets/location-assets#create-location-sync
     */
    googleMyBusiness: 'googleMyBusiness',
    /**
     * True if the account has a conversion action origin of type `YOUTUBE_HOSTED`:
     * https://developers.google.com/google-ads/api/fields/v25/conversion_action#conversion_action.origin
     */
    youtube: 'youtube',
} as const
export type Integration = (typeof Integration)[keyof typeof Integration]

export interface IntegrationsScoreSection extends Section {
    type: typeof SectionTypes.integrations
    details: Record<Integration, boolean>
}
